import PopUpModal from "./CommonPopUpModal";
import { JJ_Icon_success_save_icon } from "../../assets";
export default function SucessCommonPopup(props) {
    const { display, handleClose, data, width } = props
    var privacyHtml = `<div>${data}</div>`
    if (width <= 1000) {
        return (
            <PopUpModal color="#EB1700" height="15vh" showModal={display} header="Success" content={privacyHtml} icon={JJ_Icon_success_save_icon} handleClose={(status) => handleClose(status)} btnText="Close" btnPosition="center" btnColor="#EB1700" />
        )
    }
    else {
        return (
            <PopUpModal color="#EB1700" height="10vh" showModal={display} header="Success" content={privacyHtml} icon={JJ_Icon_success_save_icon} handleClose={(status) => handleClose(status)} btnText="Close" btnPosition="center" btnColor="#EB1700" />
        )
    }
}